import type { RouteRecordRaw } from 'vue-router';

// Alert policies. `edit/:id` and the detail `:id` both need `?region=` — the
// policy lives on that region's shard. The edit record is declared before the
// bare `:id` so `/alert/edit/x` can't be read as a policy id.
const alertRoutes: RouteRecordRaw[] = [
  {
    path: '/alert',
    name: 'alert-list',
    component: () => import('@/domains/alert/views/AlertListView.vue'),
    meta: { renderer: 'native', perms: ['alert@all'] },
  },
  {
    path: '/alert/create',
    name: 'alert-create',
    component: () => import('@/domains/alert/views/AlertPolicyFormView.vue'),
    meta: { renderer: 'native', perms: ['alert@all'] },
  },
  {
    path: '/alert/edit/:id',
    name: 'alert-edit',
    component: () => import('@/domains/alert/views/AlertPolicyFormView.vue'),
    meta: { renderer: 'native', perms: ['alert@all'] },
  },
  {
    path: '/alert/:id',
    name: 'alert-detail',
    component: () => import('@/domains/alert/views/AlertDetailView.vue'),
    meta: { renderer: 'native', perms: ['alert@all'] },
  },
];

export default alertRoutes;
